import LeaveDisplayCard from "../../components/Reusable/LeaveDisplayCard";
import userPurple from "../../assets/images/user-group-purple.png";

export default function LeaveRequestSection({
  totalLeaveRequest,
  selectedCompany,
  updateTotalLeaveRequest,
  navigate,
}) {
  return (
    <div className="h-[740px] overflow-y-scroll">
      <div className="bg-white w-full p-4 rounded-md overflow-y-auto">
        <div className="leave__main-section">
          <div className="flex items-center justify-between">
            <div className="bg-purple-100 w-10 h-10 rounded-full flex items-center justify-center">
              <img src={userPurple} alt="icon" />
            </div>

            <h4 className="font-bold text-purple-600">{totalLeaveRequest}</h4>
          </div>

          <div
            className="flex items-center justify-between mt-4 cursor-pointer"
            onClick={() => navigate("/leavemanagement")}
          >
            <p className="text-xs font-medium">Leave Request</p>
            <p className="text-xs font-medium">Last 180 Days</p>
          </div>
        </div>

        <div className="h-full">
          <LeaveDisplayCard
            selectedCompany={selectedCompany}
            updateTotalLeaveRequest={updateTotalLeaveRequest}
          />
        </div>
      </div>
    </div>
  );
}
